import { createSlice } from '@reduxjs/toolkit'

import { NameSpace } from './nameSpace'

export const appSlice = createSlice({
  name: NameSpace.APP,

  initialState: {
    city: null,
    formatsCity: null,
    cities: [],
    formats: [],
    banners: null,
  },

  reducers: {
    addStoreFormatsCity: (state, action) => {
      state.formatsCity = action.payload
    },
    addStoreCity: (state, action) => {
      state.city = action.payload
    },

    addStoreCities: (state, action) => {
      state.cities = action.payload
    },

    addStoreFormats: (state, action) => {
      state.formats = action.payload
    },

    addStoreBanners: (state, action) => {
      state.banners = action.payload
    },
  },
})

export const { addStoreCity, addStoreFormatsCity, addStoreCities, addStoreFormats, addStoreBanners } = appSlice.actions

export const getStoreCity = (state) => state[NameSpace.APP].city
export const getStoreFormatsCity = (state) => state[NameSpace.APP].formatsCity
export const getStoreCities = (state) => state[NameSpace.APP].cities
export const getStoreFormats = (state) => state[NameSpace.APP].formats
export const getStoreBanners = (state) => state[NameSpace.APP].banners

export default appSlice.reducer
